<template>
  <v-dialog
    v-model="dialog"
    :max-width="options.width"
    :style="{ zIndex: options.zIndex }"
    color="primary"
    @keydown.esc="cancel"
  >
    <v-card>
      <v-card-title class="primary my-card-title d-flex flex-nowrap align-center px-4 py-3 white--text">
        <v-icon
          medium
          left
          color="white"
        >
          {{ options.titleIcon }}
        </v-icon>
        <span class="subtitle-1 font-weight-regular">{{ title }}</span>
      </v-card-title>

      <v-card-text
        v-show="!!message"
        class="my-card-text body-1 font-weight-regular pa-4"
        v-html="message"
      />
      <v-card-actions class="my-card-actions px-4 py-2">
        <v-spacer />
        <v-btn
          v-show="options.type==='confirm'"
          color="grey darken-2 white--text"
          @click.native="cancel"
        >
          取消
        </v-btn>
        <v-btn
          color="primary white--text"
          @click.native="agree"
        >
          確認
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
/**
 * Vuetify Confirm Dialog component
 *
 * Insert component where you want to use it:
 * <confirm ref="confirm"></confirm>
 *
 * Call it:
 * this.$refs.confirm.open('Delete', 'Are you sure?', { color: 'red' }).then((confirm) => {})
 * Or use await:
 * if (await this.$refs.confirm.open('Delete', 'Are you sure?', { color: 'red' })) {
 *   // yes
 * }
 * else {
 *   // cancel
 * }
 *
 * Alternatively you can place it in main App component and access it globally via this.$root.$confirm
 * <template>
 *   <v-app>
 *     ...
 *     <confirm ref="confirm"></confirm>
 *   </v-app>
 * </template>
 *
 * mounted() {
 *   this.$root.$confirm = this.$refs.confirm.open
 * }
 */
export default {
  data: () => ({
    dialog: false,
    resolve: null,
    reject: null,
    message: null,
    title: null,
    options: {
      type: 'confirm',
      titleIcon: 'mdi-alert',
      width: 425,
      zIndex: 200

    }
  }),
  methods: {
    open (title, message, options) {
      this.dialog = true
      this.title = title
      this.message = message
      this.options = Object.assign(this.options, options)
      return new Promise((resolve, reject) => {
        this.resolve = resolve
        this.reject = reject
      })
    },
    agree () {
      this.resolve(true)
      this.dialog = false
    },
    cancel () {
      this.resolve(false)
      this.dialog = false
    }
  }
}
</script>

<style lang="scss">
  .my-card-title{
    padding: 1rem 1rem;
    background-color: #EEEEEE;
    box-shadow: 0 1px 1px rgba(0,0,0,.15);
  }

  .my-card-actions{
    border-top: 1px solid rgba(0,0,0,.1);
  }
</style>
